import * as React from 'react';

import { translate } from '~l10n/client';
import { Spinner } from '~shared/components/Spinner';
import { toast } from '~shared/components/Toast';
import { useGetActivityInsights } from '~teacher/hook';

import { InsightsBorderContainer } from './layout/InsightsBorderContainer';
import { InsightsFlexContainer } from './layout/InsightsFlexContainer';

export function InsightsPending({
  activityInstanceId,
}: {
  activityInstanceId: number;
}) {
  const activityInsights = useGetActivityInsights({
    activityInstanceId,
  });

  if (activityInsights.isError) {
    toast.critical(translate('Something Went Wrong'));
  }

  return (
    <InsightsBorderContainer>
      <InsightsFlexContainer>
        <div className="flex-shrink flex-grow-0">
          <Spinner size="small" />
        </div>
        <div className="flex-grow text-left text-blue-900 text-base font-400">
          {translate(
            'Generating may take up to a minute. You can safely leave this page while we finish up.'
          )}
        </div>
      </InsightsFlexContainer>
    </InsightsBorderContainer>
  );
}
